import { render, staticRenderFns } from "./PlansSubscriptions.vue?vue&type=template&id=1ec55275&scoped=true"
import script from "./PlansSubscriptions.vue?vue&type=script&lang=js"
export * from "./PlansSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./PlansSubscriptions.vue?vue&type=style&index=0&id=1ec55275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec55275",
  null
  
)

export default component.exports